<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Organigrama empresarial</span>
	  		    <v-spacer></v-spacer>

            <v-btn
              v-if="![31].includes( getdatosUsuarioERPERP.idpuesto )"
              class="mr-2"
              small dark color="green"
              @click="exportExcel( organigrama  , 'ORGANIGRAMA')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              v-if="![31].includes( getdatosUsuarioERPERP.idpuesto )"
              color="blue"
              dark
              class="mr-2"
              @click="dialogReporte = true"
              small
              tile
            >
              <v-icon left small>mdi-file</v-icon>
              Reporte
            </v-btn>

            <v-btn
              v-if="![31].includes( getdatosUsuarioERPERP.idpuesto )"
              color="red"
              dark
              class="mr-2"
              @click="dialogBajas = true"
              small
              tile
            >
              <v-icon left small>mdi-file</v-icon>
              Reporte Bajas
            </v-btn>

            <v-btn
              v-if="![31].includes( getdatosUsuarioERPERP.idpuesto ) || [1,334,954].includes( getdatosUsuarioERPERP.iderp )"
              color="orange"
              dark
              class="mr-2"
              @click="dialogAddOrganigrama = true"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar Organigrama
            </v-btn>

            <v-btn
              v-if="![31].includes( getdatosUsuarioERPERP.idpuesto ) || [1,334,954].includes( getdatosUsuarioERPERP.iderp )"
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row justify="end">
                <v-col cols="12" md="4" lg="3">
                  <v-autocomplete
                    v-model="filtroPlantelTabla"
                    :items="plantelesFiltroTabla"
                    item-value="id_plantel"
                    item-text="plantel"
                    label="Filtrar por plantel"
                    filled
                    dense
                    hide-details
                    clearable
                  ></v-autocomplete>
                </v-col>
	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="organigramaFiltrado"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>


                  <template v-slot:item.vacantes="{ item }">
                    <v-chip
                      small
                      color="green"
                      dark
                      label
                      @click="verDetalle(  item )"
                    >
                      {{ item.vacantes }}
                    </v-chip>
                  </template>

                  <template v-slot:item.requeridos="{ item }">
                    <v-chip
                      small
                      color="green"
                      dark
                      label
                      @click="verDetalleRequeridos(  item )"
                    >
                      {{ item.requeridos }}
                    </v-chip>
                  </template>


							    <template v-slot:item.actions="{ item }">
							    	<v-btn
							    		color="error"
							    		x-small
							    		@click="deleteItem(item)"
							    		class="mr-2"
                      v-if="[1,334,954].includes( getdatosUsuarioERPERP.iderp )"
							    	>
								      <v-icon small> mdi-delete</v-icon>
							    	</v-btn>
                    <v-btn
                      color="blue"
                      x-small
                      @click="editItem(item)"
                      class="mr-2"
                      v-if="puedeEditarOrganigrama"
                    >
                      <v-icon small> mdi-pencil</v-icon>
                    </v-btn>


                    <v-btn
                      color="blue"
                      x-small
                      @click="editItem2(item)"
                      class="mr-2"
                      v-if="[2598, 2354,2230].includes( getdatosUsuarioERPERP.iderp )"
                    >
                      <v-icon small> mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                      color="teal"
                      x-small
                      @click="verDescriptor(item)"
                      class="mr-2"
                      v-if="puedeVerDescriptor"
                      :title="item.descriptor ? 'Ver descriptor' : 'Sin descriptor'"
                    >
                      <v-icon small>mdi-file-pdf-box</v-icon>
                    </v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="640px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.id_plantel }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
          	<v-col cols="12" v-if="![ 31, 68 ].includes( getdatosUsuarioERPERP.idpuesto )">
              <v-autocomplete
                v-model="editedItem.id_jefe"
                label="Puesto Jefe"
                filled
                hide-details
                dense
                :items="puestos"
								item-value="idpuesto"
		            item-text="puesto"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" v-if="![ 31, 68 ].includes( getdatosUsuarioERPERP.idpuesto )">
              <v-autocomplete
                v-model="editedItem.id_puesto"
                label="Pueso Auxiliar"
                filled
                hide-details
                dense
                :items="puestos"
								item-value="idpuesto"
		            item-text="puesto"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" v-if="![ 31, 68 ].includes( getdatosUsuarioERPERP.idpuesto )">
              <v-autocomplete
                v-model="editedItem.id_turno"
                label="Turno"
                filled
                hide-details
                dense
                :items="turnos"
								item-value="idturnos"
		            item-text="turno"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" v-if="![ 31, 68 ].includes( getdatosUsuarioERPERP.idpuesto )">
              <v-autocomplete
                v-model="editedItem.id_plantel"
                label="Plantel"
                filled
                hide-details
                dense
                :items="planteles"
								item-value="id_plantel"
		            item-text="plantel"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" v-if="![ 31, 68 ].includes( getdatosUsuarioERPERP.idpuesto )">
              <v-text-field
                v-model="editedItem.requeridos"
                label="Requeridos"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" v-if="puedeEditarDescriptorPdf">
              <v-divider class="my-2"></v-divider>
              <div class="text-subtitle-2 mb-2 black--text">Descriptor (PDF)</div>
              <v-file-input
                v-model="descriptorArchivo"
                label="Subir o reemplazar PDF del descriptor"
                filled
                dense
                hide-details
                accept=".pdf,application/pdf"
                prepend-icon="mdi-file-pdf-box"
                @change="onDescriptorArchivoChange"
              ></v-file-input>
              <v-btn
                v-if="descriptorArchivo"
                color="primary"
                small
                tile
                dark
                class="mt-3 text-capitalize"
                :loading="cargarDescriptor"
                @click="saveDescriptorPdf"
              >
                <v-icon small left>mdi-content-save</v-icon>
                Guardar PDF
              </v-btn>
            </v-col>

            <v-col cols="12" v-if="descriptorPreviewSrc">
              <embed :src="descriptorPreviewSrc" type="application/pdf" width="100%" height="400px"/>
            </v-col>
            <v-col cols="12" v-else>
              <v-alert type="info" dense text class="mb-0">
                Sin descriptor PDF asignado para este puesto.
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="![ 31, 68 ].includes( getdatosUsuarioERPERP.idpuesto )"
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="save"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo Add Organigrama-->
	  <v-dialog
      v-model="dialogAddOrganigrama"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Agregar Organigrama</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.id_plantel }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>

            <v-col cols="12">
              <v-autocomplete
                v-model="itemAddOrganigrama"
                label="Departamento"
                filled
                hide-details
                dense
                :items="departamentos"
								item-value="iddepartamento"
		            item-text="departamento"
                return-object
                @change="onDepartamentoChange"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-file-input
                v-model="itemAddOrganigrama.archivo"
                label="Subir archivo"
                filled
                dense
                hide-details
                accept=".pdf, image/png, image/jpeg"
                prepend-icon="mdi-upload"
              ></v-file-input>
            </v-col>

            <v-col cols="12" v-if="itemAddOrganigrama.archivo">
              <embed :src="urlOrg + archivo" type="application/pdf" width="100%" height="600px"/>
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="dialogAddOrganigrama = false"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="![ 31, 68 ].includes( getdatosUsuarioERPERP.idpuesto )"
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="saveOrganigrama"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog2"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ tituloDialogDescriptor }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1" v-if="editedItem.puesto">
            <strong>{{ editedItem.puesto }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row v-if="!soloLecturaDescriptor">
            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.id_jefe"
                label="Puesto Jefe"
                filled
                hide-details
                dense
                :items="puestos"
                item-value="idpuesto"
                item-text="puesto"
                readonly
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.id_puesto"
                label="Pueso Auxiliar"
                filled
                hide-details
                dense
                :items="puestos"
                item-value="idpuesto"
                item-text="puesto"
                readonly
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.id_turno"
                label="Turno"
                filled
                hide-details
                dense
                :items="turnos"
                item-value="idturnos"
                item-text="turno"
                readonly
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.id_plantel"
                label="Plantel"
                filled
                hide-details
                dense
                :items="planteles"
                item-value="id_plantel"
                item-text="plantel"
                readonly
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="editedItem.requeridos"
                label="Requeridos"
                filled
                hide-details
                dense
                type="number"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col cols="12" md="6"><strong>Puesto:</strong> {{ editedItem.puesto || '—' }}</v-col>
            <v-col cols="12" md="6"><strong>Departamento:</strong> {{ editedItem.departamento || '—' }}</v-col>
            <v-col cols="12" md="6"><strong>Jefe directo:</strong> {{ editedItem.puesto_jefe || '—' }}</v-col>
            <v-col cols="12" md="6"><strong>Plantel:</strong> {{ editedItem.plantel || '—' }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="12" v-if="descriptorUrlCompleta">
              <embed :src="descriptorUrlCompleta" type="application/pdf" width="100%" height="600px"/>
            </v-col>
            <v-col cols="12" v-else>
              <v-alert type="info" dense text class="mb-0">
                Sin descriptor PDF asignado para este puesto.
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close2"
          >
            <v-icon small left>mdi-close</v-icon>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="descriptorUrlCompleta"
            color="green"
            tile
            dark
            small
            @click="descargarDescriptor"
          >
            <v-icon small left>mdi-download</v-icon>
            Descargar PDF
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo de detalle de la vacante -->
    <v-dialog
      v-model="dialogDetalles"
      max-width="1200px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          Detalles de la vacante
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="black--text">
          <v-row>
            <v-col cols="12">
              <b>Puesto: </b> {{ editedItem.puesto }}
            </v-col>
          </v-row>

          <br/>

          <v-data-table
            :headers="headersDetalles"
            :items="vacantes_detalles"
            class="elevation-0"
            :mobile-breakpoint="100"
            dense
          >

            <template v-slot:item.sexo="{ item }">
              <v-chip color="orange" v-if="item.sexo_i == 1" small dark >Ind.</v-chip>
              <v-chip color="pink"   v-if="item.sexo_i == 2" small dark >F</v-chip>
              <v-chip color="blue"   v-if="item.sexo_i == 2" small dark >M</v-chip>
            </template>

            <template v-slot:item.fecha_compromiso="props">
              <v-edit-dialog
                :return-value.sync="props.item.fecha_compromiso"
                @save="updateVacante( props.item )"
                v-if="[1,334,954,966].includes( getdatosUsuarioERPERP.iderp )"

              >
                {{ props.item.fecha_compromiso }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.fecha_compromiso"
                    label="Fecha compromiso"
                    single-line
                    type="date"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:item.nombre_reclutador="props">
              <v-edit-dialog
                v-if="[1,334,954,966].includes( getdatosUsuarioERPERP.iderp )"
                :return-value.sync="props.item.reclutador"
                @save="updateVacante( props.item )"
              >
                {{ props.item.nombre_reclutador }}
                <template v-slot:input>
                  <v-autocomplete
                    label="Reclutador"
                    filled
                    dense
                    hide-details
                    v-model="props.item.reclutador"
                    :items="usuarios"
                    item-text="name"
                    item-value="iderp"
                    clearable
                  ></v-autocomplete>

                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogRequeridos"
      max-width="1400px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          Detalles de los requeridos
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            small
            class="mr-2"
            @click="exportExcelRequeridosDetalles"
          >
            <v-icon small left>mdi-microsoft-excel</v-icon>
            Excel
          </v-btn>
          <v-btn
            color="orange"
            @click="dialogAddDetalle = true"
            v-if="[1,334,954,2230,966].includes( getdatosUsuarioERPERP.iderp )"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0 pb-0">
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filtroPlantelRequeridos"
                :items="plantelesFiltroTabla"
                item-value="id_plantel"
                item-text="plantel"
                label="Filtrar requeridos por plantel"
                filled
                dense
                hide-details
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="black--text">
          <v-row>
            <v-col cols="12">
              <b>Puesto: </b> {{ editedItem.puesto }}
            </v-col>
          </v-row>

          <br/>

          <v-data-table
            :headers="headersRequeridos"
            :items="vacantesRequeridosFiltrados"
            class="elevation-0"
            :mobile-breakpoint="100"
            dense
          >

            <template v-slot:item.sexo="{ item }">
              <v-chip color="pink"   v-if="item.sexo_i == 2" small dark >F</v-chip>
              <v-chip color="orange" v-else small dark >Ind.</v-chip>
            </template>

            <template v-slot:item.estatus="{ item }">
              <v-chip color="green" v-if="item.estatus == 1"       small dark >Activo</v-chip>
              <v-chip color="error" v-else-if="item.estatus == 2"  small dark >Baja solicitada</v-chip>
              <v-chip color="red"   v-else                 small dark >Vacante</v-chip>
            </template>

            <template v-slot:item.fecha_compromiso="props">
              <v-edit-dialog
                v-if="[1,334,954,966].includes( getdatosUsuarioERPERP.iderp )"
                :return-value.sync="props.item.fecha_compromiso"
                @save="updateVacante( props.item )"
              >
                {{ props.item.fecha_compromiso }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.fecha_compromiso"
                    label="Fecha compromiso"
                    single-line
                    type="date"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
              <span v-else>{{ props.item.fecha_compromiso }}</span>
            </template>

            <template v-slot:item.nombre_reclutador="props">
              <v-edit-dialog
                v-if="[1,334,954,966].includes( getdatosUsuarioERPERP.iderp )"
                :return-value.sync="props.item.reclutador"
                @save="updateVacante( props.item )"
              >
                {{ props.item.nombre_reclutador }}
                <template v-slot:input>
                  <v-autocomplete
                    label="Reclutador"
                    filled
                    dense
                    hide-details
                    v-model="props.item.reclutador"
                    :items="usuarios"
                    item-text="name"
                    item-value="iderp"
                    clearable
                  ></v-autocomplete>

                </template>
              </v-edit-dialog>
              <span v-else>{{ props.item.nombre_reclutador }}</span>
            </template>

            <template v-slot:item.trabajador="{ item }">
              <div class="d-flex align-center">
                <template v-if="[1,334,954,966].includes( getdatosUsuarioERPERP.iderp )">
                  <template v-if="item.id_trabajador">
                    <v-btn
                      icon
                      x-small
                      color="error"
                      class="mr-2"
                      @click="quitarTrabajadorVacante(item, 1)"
                      title="Quitar trabajador"
                    >
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                    <span>{{ item.trabajador || item.id_trabajador }}</span>
                  </template>
                  <v-autocomplete
                    v-else
                    dense
                    filled
                    hide-details
                    clearable
                    label="Trabajador"
                    :items="trabajadoresParaAsignar"
                    item-text="nombre_completo"
                    item-value="id_trabajador"
                    class="mr-2"
                    @change="asignarTrabajadorVacante(item, $event)"
                  ></v-autocomplete>
                </template>
                <span v-else>
                  {{ item.trabajador || 'Sin asignar' }}
                </span>
              </div>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn
                color="error"
                x-small
                @click="eliminarVacante( item )"
                v-if="[1,334,954,2230,966].includes( getdatosUsuarioERPERP.iderp )"
                class="mr-2"
              >
                <v-icon small> mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- AGREGAR DETALLE -->
    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialogAddDetalle"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>ID: {{ editedItemDetalle.idseguimiento_campanias }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>

            <v-col cols="12">
              <v-autocomplete
                label="Sucursal"
                filled
                dense
                hide-details
                v-model="editedItemDetalle.id_plantel"
                :items="planteles"
                item-text="plantel"
                item-value="id_plantel"
                clearable
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                label="Elige un turno"
                filled
                dense
                hide-details
                v-model="editedItemDetalle.id_turno"
                :items="turnos"
                item-text="turno"
                item-value="idturnos"
                clearable
              ></v-autocomplete>
            </v-col>

            <!-- <v-col cols="12">
              <v-text-field
                v-model="editedItemDetalle.cantidad"
                label="Autorizados"
                filled
                hide-details
                dense
                type="number"
                v-if="[1,334,954].includes( getdatosUsuarioERPERP.iderp )"
              ></v-text-field>
            </v-col> -->

            <v-col cols="12" >
              <v-radio-group
                v-model="editedItemDetalle.sexo_i"
                row
              >
                <v-radio
                  label="Indistinto"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="Femenino"
                  :value="2"
                ></v-radio>
                <v-radio
                  label="Masculino"
                  :value="3"
                ></v-radio>
              </v-radio-group>

            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="editedItemDetalle.fecha_apertura"
                label="Fecha apertura"
                filled
                hide-details
                dense
                type="date"
              ></v-text-field>
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="dialogAddDetalle = false"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="addVacanteDetalle( )"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Reporte -->
    <v-dialog
      v-model="dialogReporte"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Reporte de vacantes</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headersDetalles"
            :items="vacantes_detalles_all"
            class="elevation-0"
            :mobile-breakpoint="100"
            dense
          >

            <template v-slot:item.sexo="{ item }">
              <v-chip color="orange" v-if="item.sexo_i == 1" small dark >Ind.</v-chip>
              <v-chip color="pink"   v-if="item.sexo_i == 2" small dark >F</v-chip>
              <v-chip color="blue"   v-if="item.sexo_i == 2" small dark >M</v-chip>
            </template>

            <template v-slot:item.fecha_compromiso="props">
              <v-edit-dialog
                :return-value.sync="props.item.fecha_compromiso"
                @save="updateVacante( props.item )"
              >
                {{ props.item.fecha_compromiso }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.fecha_compromiso"
                    label="Fecha compromiso"
                    single-line
                    type="date"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:item.nombre_reclutador="props">
              <v-edit-dialog
                :return-value.sync="props.item.reclutador"
                @save="updateVacante( props.item )"
              >
                {{ props.item.nombre_reclutador }}
                <template v-slot:input>
                  <v-autocomplete
                    label="Reclutador"
                    filled
                    dense
                    hide-details
                    v-model="props.item.reclutador"
                    :items="usuarios"
                    item-text="name"
                    item-value="iderp"
                    clearable
                  ></v-autocomplete>

                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="dialogReporte = false"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de bajas -->
    <v-dialog
      v-model="dialogBajas"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Reporte de vacantes</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headersBajas"
            :items="reporteBajas"
            class="elevation-0"
            :mobile-breakpoint="100"
            dense
          >

            <template v-slot:item.sexo="{ item }">
              <v-chip color="orange" v-if="item.sexo_i == 1" small dark >Ind.</v-chip>
              <v-chip color="pink"   v-if="item.sexo_i == 2" small dark >F</v-chip>
              <v-chip color="blue"   v-if="item.sexo_i == 2" small dark >M</v-chip>
            </template>

            <template v-slot:item.estatus="{ item }">
              <v-chip color="green"  v-if="item.estatus == 1"       small dark >Activo</v-chip>
              <v-chip color="error"  v-else-if="item.estatus == 2"  small dark @click="verBajas( item )">Baja solicitada</v-chip>
              <v-chip color="orange" v-else-if="item.estatus == 4"  small dark @click="verBajas( item )">Retenido</v-chip>
              <v-chip color="red"   v-else                 small dark >Vacante</v-chip>
            </template>

          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="dialogBajas = false"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de bajas -->
    <v-dialog
      v-model="dialogBaja"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Historial de la baja</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>

          <v-row>
            <v-col cols="12" v-for="( baja, i ) in bajas" :key="i">
              <v-card class="shadowCard">
                <v-card-text>
                  <b>Solicitó</b>: {{ baja.solicito }}<br/>
                  <b>Colaborador</b>: {{ baja.colaborador }}<br/>
                  <b>Fecha</b>: {{ baja.fecha_creacion }}<br/>
                  <b>Tipo Baja</b>:
                    <span v-if="editedItem.tipo_baja == 1">Baja programada</span>
                    <span v-if="editedItem.tipo_baja == 2">Baja automática</span>
                  <br/>
                  <b>Fecha Baja</b>: {{ editedItem.fecha_baja }}<br/>
                  <b>Motivo</b>: {{ baja.motivo }}<br/>
                  <b>Motivo Rechazo</b>: {{ baja.motivo_rechazo }}<br/>
                  <b>Estatus:</b>
                    <span v-if="baja.estatus == 0">Pendiente</span>
                    <span v-if="baja.estatus == 1">Cerrado</span>
                  <br/>
                  <br/>
                  <br/>

                  <v-textarea
                    v-if="rechazado == true && baja.estatus == 0"
                    v-model="motivorechazo"
                    label="Ingresa el motivo del rechazo"
                    :rows="3"
                    filled
                    dense
                  >
                  </v-textarea>
                </v-card-text>
                <v-card-actions v-if="baja.estatus == 0">
                  <v-btn small color="red"     dark class="mr-2" @click="rechazado = true"        v-if="rechazado == false">Rechazar</v-btn>
                  <v-btn small color="orange"  dark class="mr-2" @click="retener( baja )"         v-if="rechazado == false">Retenido</v-btn>
                  <v-btn small color="success" dark              @click="aceptarBaja( baja )"     v-if="rechazado == false">Aceptar </v-btn>
                  <v-btn small color="red"     dark class="mr-2" @click="rechazar( baja )"        v-if="rechazado == true" >Rechazar petición</v-btn>
                  <v-btn small color="black"   dark class="mr-2" @click="rechazado = false"       v-if="rechazado == true" >Cancelar</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="dialogBaja = false"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogAddOrganigrama: false,
      dialogDelete: false,
      descriptorArchivo: null,
      descriptorObjectUrl: null,
      cargarDescriptor: false,

      editedIndex: -1,
      archivo: null,
      editedItem: {
        id_puesto:0,
        id_jefe:0,
        id_turno:0,
        id_plantel:0,
        requeridos:0,
        deleted: 0,
        fecha_creacion: null,
      },

      itemAddOrganigrama: {
        iddepartamento: 0,
        archivo: null
      },

      defaultItem: {
        id_puesto:0,
        id_jefe:0,
        id_turno:0,
        id_plantel:0,
        requeridos:0,
        deleted: 0,
        fecha_creacion: null,
      },

      // Filtros:
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      organigrama: [],
      puestos:[],
      planteles:[],
      departamentos: [],
			turnos:[],
      headers: [
        { text: 'Puesto'         , value: 'puesto'      },
        { text: 'Departamento'   , value: 'departamento'},
        { text: 'Jefe direcoto'  , value: 'puesto_jefe' },
        { text: 'Turno'          , value: 'turno'       },
        { text: 'Plantel'        , value: 'plantel'     },
        { text: 'Autorizados'    , value: 'requeridos'  },
        { text: 'Activos'        , value: 'activos'     },
        { text: 'Actions'        , value: 'actions', sortable: false },
      ],
      url:'',
      urlOrg: '',
      archivo: '',

      bajas:[],

      vacantes_detalles:[],
      dialogDetalles: false,

      headersDetalles: [
        { text: 'Puesto'               , value: 'puesto'                   },
        { text: 'Sexo'                 , value: 'sexo'                     },
        { text: 'Turno'                , value: 'turno'                    },
        { text: 'Plantel  '            , value: 'plantel'                  },
        { text: 'F. Apertura'          , value: 'fecha_apertura'           },
        { text: 'F. Compromiso'        , value: 'fecha_compromiso'         },
        { text: 'Reclutador'           , value: 'nombre_reclutador'        },
        { text: 'Días espera'          , value: 'dias_sin_cubrir'          },
      ],


      editedItemDetalle: {
        idseguimiento_campanias: 0,
        id_sucursal: 0,
        id_puesto: 0,
        id_turno: 0,
        id_coordinadora: 0,
        campania: '',
        resultado_mkt: 0,
        resultado_rh: 0,
        funciona: 0,
        deleted:0,
        fecha_creacion:null,
        fecha_compromiso: null,
        estatus: 1,
        sexo:0,
        cantidad:0,
        fecha_apertura: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },

      defaultItemDetalle: {
        idseguimiento_campanias: 0,
        id_sucursal: 0,
        id_puesto: 0,
        id_turno: 0,
        id_coordinadora: 0,
        campania: '',
        resultado_mkt: 0,
        resultado_rh: 0,
        funciona: 0,
        deleted:0,
        fecha_creacion:null,
        fecha_compromiso: null,
        estatus: 1,
        sexo:0,
        cantidad:0,
        fecha_apertura: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },

      dialogAddDetalle: false,
      puestosAll: [],

      usuarios: [],
      teachersActivos: [],

      vacantes_requeridos:[],
      dialogRequeridos: false,
      filtroPlantelTabla: null,
      filtroPlantelRequeridos: null,

      headersRequeridos:[
        { text: 'Folio'                , value: 'folio'                    },
        { text: 'Sexo'                 , value: 'sexo'                     },
        { text: 'Turno'                , value: 'turno'                    },
        { text: 'Plantel  '            , value: 'plantel'                  },
        { text: 'F. Apertura'          , value: 'fecha_apertura'           },
        { text: 'Trabajador'           , value: 'trabajador'               },
        { text: 'Estatus'              , value: 'estatus'                  },
        { text: 'F. Compromiso'        , value: 'fecha_compromiso'         },
        { text: 'Reclutador'           , value: 'nombre_reclutador'        },
        { text: 'Días espera'          , value: 'dias_sin_cubrir'          },
        { text: 'Entrevistas'          , value: 'entrevistas'              },
        { text: 'Actions'              , value: 'actions', sortable: false },
      ],

      dialogReporte: false,
      dialogBajas: false,

      dialogBaja: false,

      headersBajas:[
        { text: 'Folio'                , value: 'folio'                    },
        { text: 'Sexo'                 , value: 'sexo'                     },
        { text: 'Turno'                , value: 'turno'                    },
        { text: 'Plantel  '            , value: 'plantel'                  },
        { text: 'Trabajador'           , value: 'trabajador'               },
        { text: 'Estatus'              , value: 'estatus'                  },
        { text: 'Actions'              , value: 'actions', sortable: false },
      ],

      rechazado: false,
      motivorechazo: '',

      solicitud: null,

      dialog2: false,
      soloLecturaDescriptor: false,

    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar datos' : 'Editar datos'
      },

      puedeEditarDescriptorPdf () {
        const u = this.getdatosUsuarioERPERP || {}
        return Number(u.iderp) === 334
      },

      puedeVerDescriptor () {
        const u = this.getdatosUsuarioERPERP || {}
        return Number(u.idpuesto) === 108
      },

      puedeEditarOrganigrama () {
        const u = this.getdatosUsuarioERPERP || {}
        return Number(u.idpuesto) === 31 || [1, 334, 954, 966, 2598, 2354, 2230].includes(Number(u.iderp))
      },

      /** Teachers (10), encargadas (18) y recepcionistas (19) activos para ligar a vacantes. */
      trabajadoresParaAsignar () {
        const lista = this.teachersActivos || []
        const idPuesto = Number(this.editedItem && this.editedItem.id_puesto)
        if ([10, 18, 19].includes(idPuesto)) {
          return lista.filter(t => Number(t.id_puesto) === idPuesto)
        }
        return lista
      },

      tituloDialogDescriptor () {
        return this.soloLecturaDescriptor ? 'Descriptor de puesto' : this.formTitle
      },

      descriptorUrlCompleta () {
        if (!this.editedItem || !this.editedItem.descriptor) return null
        return this.url + this.editedItem.descriptor
      },

      descriptorPreviewSrc () {
        if (this.descriptorObjectUrl) return this.descriptorObjectUrl
        if (this.editedItem.descriptor) return this.url + this.editedItem.descriptor
        return null
      },

      vacantes_detalles_all( ){

        let arreglo = []
        for( const i in this.organigrama){

          const { vacantes, vacantes_detalles } = this.organigrama[i]

          if( vacantes > 0 ){
            arreglo = arreglo.concat( vacantes_detalles )
          }

        }

        return arreglo
      },

      reporteBajas( ){

        let reporte = []

        for( const i in this.organigrama ){

          const { vacantes_requeridos } = this.organigrama[i]

          for( const j in vacantes_requeridos ){

            const { estatus } = vacantes_requeridos[j]

            if( [2,4, 3].includes( estatus ) ){
              reporte.push( vacantes_requeridos[j] )
            }


          }




        }

        return reporte

      },
      plantelesFiltroTabla () {
        return [{ id_plantel: null, plantel: 'Todos los planteles' }, ...(this.planteles || [])]
      },
      organigramaFiltrado () {
        let rows = this.organigrama || []
        if (this.filtroPlantelTabla) {
          rows = rows.filter(r => r.id_plantel == this.filtroPlantelTabla)
        }
        return rows
      },
      vacantesRequeridosFiltrados () {
        let rows = this.vacantes_requeridos || []
        if (this.filtroPlantelRequeridos) {
          rows = rows.filter(r => r.id_plantel == this.filtroPlantelRequeridos)
        }
        return rows
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      dialog2 (val) {
        val || this.close2()
      },

    },

    beforeDestroy () {
      this.revokeDescriptorPreview()
    },

    async created () {
      this.url = 'https://escuelakpi.club/documentacionrh/'
      this.urlOrg = 'https://escuelakpi.club/kpi/organigrama/2656f298-3895-45ca-8d8a-2088e2017222.pdf'
      //this.urlOrg = 'http://localhost:3004/organigrama/'

      await this.initialize( )
      await this.getPuestos( )
      await this.getPlanteles()
      await this.getDepartamentos()
      await this.getTurnos( )
      await this.getUsuarios( )
      await this.getTeachersActivos()
      console.log( this.getdatosUsuarioERPERP.idpuesto )
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.organigrama = []
        return this.$http.get('organigrama.v2').then(response=>{

          if( this.getdatosUsuarioERPERP.iderp == 2155 ){

            this.organigrama = response.data.respuesta.filter( el => el.departamento == 'OPERACIONES')

          }else{

        	  this.organigrama = response.data.respuesta

          }
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      onDepartamentoChange(dep) {
        this.archivo = dep.archivo;
      },

      getPuestos () {
      	this.cargar = true
        this.puestos = []
        this.puestosAll = []
        return this.$http.get('organigrama.puestos').then(response=>{
          this.puestos = response.data.getPuestos
        	this.puestosAll = response.data.getPuestos
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getUsuarios () {
        this.cargar = true
        this.usuarios = []
        return this.$http.get('vacantes.list').then(response=>{
          this.usuarios      = response.data.reclutadoras

          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },
      getTeachersActivos () {
        // Puestos asignables en detalles de requeridos: teacher, encargada, recepción
        const puestos = [10, 18, 19]
        return Promise.all(
          puestos.map(puesto =>
            this.$http.get('trabajadores.erp.get.trabajadoreserp', {
              params: { activos: 'Activos', puesto },
            })
          )
        ).then(responses => {
          const mapa = new Map()
          responses.forEach(response => {
            const lista = Array.isArray(response.data) ? response.data : []
            lista.forEach(t => {
              if (t && t.id_trabajador != null) mapa.set(t.id_trabajador, t)
            })
          })
          this.teachersActivos = Array.from(mapa.values())
        }).catch(error => {
          this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al obtener trabajadores activos')
        })
      },

      addVacanteDetalle( ){

        this.cargar = true
        this.editedItemDetalle.id_puesto = this.editedItem.id_puesto

        // Lo mandapos por el EP
        this.$http.post('seguimiento.vacantes.add', this.editedItemDetalle).then(response=>{
          this.initialize( )
          this.dialogAddDetalle = false
          this.editedItemDetalle = Object.assign({}, this.defaultItemDetalle)
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      updateVacante( item ){

        this.cargar = true
        item.id_puesto = this.editedItem.id_puesto

        // Lo mandapos por el EP
        this.$http.put('seguimiento.vacantes.update/' + item.idseguimiento_campanias, item).then(response=>{
          this.initialize( )
          this.validarSuccess('Datos actualizados correctamente')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },
      asignarTrabajadorVacante(item, idTrabajador){
        if (!idTrabajador) return

        const teacher = (this.teachersActivos || []).find(t => t.id_trabajador == idTrabajador)
        if (!teacher) {
          this.validarError('No se encontró el trabajador seleccionado')
          return
        }

        this.cargar = true

        item.tipo = 2
        item.id_trabajador = teacher.id_trabajador
        item.trabajador = teacher.nombre_completo || ''

        // Lo mandapos por el EP
        this.$http.put('seguimiento.ligar.desligar/' + item.idseguimiento_campanias, item).then(response=>{
          this.updateVacante(item)
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },
      quitarTrabajadorVacante(item, tipo){

        this.cargar = true

        item.tipo = tipo

        // Lo mandapos por el EP
        this.$http.put('seguimiento.ligar.desligar/' + item.idseguimiento_campanias, item).then(response=>{
          item.id_trabajador = 0
          item.trabajador = ''
          this.updateVacante(item)
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
    
      },

      eliminarVacante( item ){

        this.cargar = true
        item.deleted = 1

        // Lo mandapos por el EP
        this.$http.put('seguimiento.vacantes.update/' + item.idseguimiento_campanias, item).then(response=>{
          this.initialize( )
          this.validarSuccess('Datos actualizados correctamente')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{
          this.planteles = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getDepartamentos () {
      	this.cargar = true
        this.departamentos = []
        return this.$http.get('departamentos.activos').then(response=>{
          this.departamentos = response.data
          //console.log( 'Departamentos' )
          //console.log( response.data )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getTurnos( ){
        this.cargar = true
        this.turnos = []
        this.$http.get('seguimiento.turnos').then(response=>{
          this.turnos = response.data
          console.log( this.turnos )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.revokeDescriptorPreview()
        this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      editItem2(item) {
        this.soloLecturaDescriptor = false
        this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog2 = true
      },

      verDescriptor (item) {
        this.soloLecturaDescriptor = true
        this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog2 = true
      },

      descargarDescriptor () {
        const src = this.descriptorUrlCompleta
        if (!src) {
          this.validarErrorDirecto('No hay descriptor PDF para descargar.')
          return
        }
        window.open(src, '_blank', 'noopener,noreferrer')
      },

      deleteItem (item) {
        this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('organigrama.v2/' + this.editedItem.idnuevo_organigrama, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.revokeDescriptorPreview()
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      revokeDescriptorPreview () {
        if (this.descriptorObjectUrl) {
          URL.revokeObjectURL(this.descriptorObjectUrl)
          this.descriptorObjectUrl = null
        }
        this.descriptorArchivo = null
      },

      onDescriptorArchivoChange () {
        if (this.descriptorObjectUrl) {
          URL.revokeObjectURL(this.descriptorObjectUrl)
          this.descriptorObjectUrl = null
        }
        if (this.descriptorArchivo) {
          this.descriptorObjectUrl = URL.createObjectURL(this.descriptorArchivo)
        }
      },

      async saveDescriptorPdf () {
        if (!this.descriptorArchivo || !this.editedItem.id_puesto) {
          this.validarErrorDirecto('Selecciona un archivo PDF')
          return
        }

        this.cargarDescriptor = true
        const form = new FormData()
        form.append('id_puesto', this.editedItem.id_puesto)
        form.append('archivo', this.descriptorArchivo)

        try {
          const { data } = await this.$http.post('subir.descriptor.puesto', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
            transformRequest: [(payload, headers) => {
              delete headers['Content-Type']
              return payload
            }],
          })

          this.editedItem.descriptor = data.filename
          this.validarSuccess(data.message || 'Descriptor actualizado correctamente')
          this.revokeDescriptorPreview()
          await this.initialize()
        } catch (error) {
          const message = (error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : 'No se pudo subir el descriptor'
          this.validarError(message)
        } finally {
          this.cargarDescriptor = false
        }
      },

      close2() {
        this.dialog2 = false
        this.soloLecturaDescriptor = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      verDetalle( item ){
        this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.vacantes_detalles = item.vacantes_detalles
        this.dialogDetalles = true

      },

      verDetalleRequeridos( item ){
        this.editedIndex         = this.organigrama.indexOf(item)
        this.editedItem          = Object.assign({}, item)
        this.vacantes_requeridos = item.vacantes_requeridos
        this.filtroPlantelRequeridos = null
        this.dialogRequeridos    = true

      },

      exportExcelRequeridosDetalles () {
        const puesto = (this.editedItem && this.editedItem.puesto) ? String(this.editedItem.puesto) : ''
        const rows = this.vacantesRequeridosFiltrados || []
        const sexoTxt = (item) => (item.sexo_i == 2 ? 'F' : 'Ind.')
        const estatusTxt = (item) => {
          if (item.estatus == 1) return 'Activo'
          if (item.estatus == 2) return 'Baja solicitada'
          return 'Vacante'
        }
        const dataExport = rows.map((item) => ({
          Puesto: puesto,
          Folio: item.folio,
          Sexo: sexoTxt(item),
          Turno: item.turno,
          Plantel: item.plantel,
          'F. Apertura': item.fecha_apertura,
          Trabajador: item.trabajador,
          Estatus: estatusTxt(item),
          'F. Compromiso': item.fecha_compromiso,
          Reclutador: item.nombre_reclutador,
          'Días espera': item.dias_sin_cubrir,
          Entrevistas: item.entrevistas
        }))
        const safe = puesto.replace(/[^\w\u00C0-\u024f\-]+/g, '_').replace(/_+/g, '_').slice(0, 48) || 'export'
        this.exportExcel(dataExport, 'Detalles_requeridos_' + safe)
      },

      save () {
      	if(this.editedItem.horario == ''){
      		this.validarErrorDirecto('Favor de llenar todos los campos')
      	}
      	// Cargamos al usuario que hizo el cambio
      	this.editedItem['id_usuario'] = this.getdatosUsuarioERPERP.iderp
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('organigrama.v2/' + this.editedItem.idnuevo_organigrama, this.editedItem).then(response=>{
          	this.validarSuccess( response.data.message )
          	this.initialize()
        		this.close()
	        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('organigrama.v2', this.editedItem).then(response=>{
          	this.initialize()
	        	this.cargar = false
        		this.close()
	        }).catch( error =>{
          	this.validarError( error.response.data.message )
        	}).finally( () => { this.cargar = false })
        }
      },

      async saveOrganigrama() {
        this.cargar = true

        try {

          const form = new FormData()

          form.append("iddepartamento", this.itemAddOrganigrama.iddepartamento)
          form.append("archivo", this.itemAddOrganigrama.archivo)


          console.log( this.itemAddOrganigrama )

          try {
            this.$http.post('subir.organigrama', form, {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              transformRequest: [function (data, headers) {
                // Eliminar Content-Type automático para que axios lo establezca correctamente
                delete headers['Content-Type']
                return data
              }]
            }).then( res => {
              console.log( res )
            })

          } catch (error) {
            console.log( error )
          }

          //this.validarSuccess(response.data.message)
          //this.initialize()
          this.close()
        }
        catch (error) {
          this.validarError(error.response.data.message)
        }
        finally {
          this.cargar = false
        }
      },

      verBajas( item ){
        this.editedIndex         = this.organigrama.indexOf(item)
        this.editedItem          = Object.assign({}, item)
        this.bajas               = item.bajas
        this.dialogBaja = true
      },

      async retener( baja ){

        try{


          const payload = {
            idseguimiento_campanias: baja.idseguimiento_campanias,
            motivo_rechazo: this.motivorechazo,
            idsolicitud_bajas: baja.idsolicitud_bajas,
            estatus_baja: 1, // Contestado
            estatus_seguimiento: 4, // Rechazo,
            id_acepta: this.getdatosUsuarioERPERP.iderp
          }


          const { data } = await this.$http.post('organigrama.rechazo', payload )

          this.initialize()
          this.motivorechazo = ''
          this.dialogBaja    = false
          this.rechazado     = false
          this.cargar        = false
          this.close()

        } catch ( error ){

          this.validarError( error.response.data.message )

        }

      },

      async aceptarBaja( baja ){

        try{


          const payload = {

            idseguimiento_campanias: baja.idseguimiento_campanias,
            motivo_rechazo         : this.motivorechazo,
            idsolicitud_bajas      : baja.idsolicitud_bajas,
            estatus_baja           : 1, // Contestado
            estatus_seguimiento    : 0, // Rechazo,
            id_acepta              : this.getdatosUsuarioERPERP.iderp,
            id_trabajador          : this.editedItem.id_trabajador,
            tipo_baja              : this.editedItem.tipo_baja
          }


          const { data } = await this.$http.post('organigrama.aceptar', payload )

          this.initialize()
          this.motivorechazo = ''
          this.dialogBaja    = false
          this.rechazado     = false
          this.cargar        = false
          this.close()

        } catch ( error ){

          this.validarError( error.response.data.message )

        }

      },

      async rechazar( baja ){

        if( this.motivorechazo == '' ){ return this.validarErrorDirecto('Favor de ingresar un motivo de rechazo') }

        try{


          const payload = {
            idseguimiento_campanias: baja.idseguimiento_campanias,
            motivo_rechazo: this.motivorechazo,
            idsolicitud_bajas: baja.idsolicitud_bajas,
            estatus_baja: 1, // Contestado
            estatus_seguimiento: 3, // Rechazo,
            id_acepta: this.getdatosUsuarioERPERP.iderp
          }


          const { data } = await this.$http.post('organigrama.rechazo', payload )

          this.initialize()
          this.motivorechazo = ''
          this.dialogBaja    = false
          this.rechazado     = false
          this.cargar        = false
          this.close()

        } catch ( error ){

          this.validarError( error.response.data.message )

        }

      }
    },
  }
</script>


